import 'css-chunk:src/feature/page/PagePanelHeader.module.scss';export default {
  "root": "PagePanelHeader_root"
};